import { Input, InputRightElement, Button } from '@chakra-ui/react'
import React from 'react'
import FieldWrapper from '../FieldWrapper'

const DummyInput = ({ value = '', showButton = false, buttonText = '', buttonFunction = () => {}, ...rest }) => (
  <FieldWrapper isRequired={false} tooltip={value} {...rest}>
    <Input value={value} disabled />
    {showButton && (
      <InputRightElement width="4.5rem">
        <Button h="1.75rem" size="sm" onClick={buttonFunction}>
          {buttonText}
        </Button>
      </InputRightElement>
    )}
  </FieldWrapper>
)

export default DummyInput
